import { get } from 'lodash'
import { Block, Link, Typography } from '@xprog/prensa'
import React from 'react'

import { PrensaEngineCSSProp } from '@xprog/prensa/types'

import { convertLocaleDateWithoutTime } from './utils'

type EditaisTeaserProps = {
  children?: any
  className?: string
  customLink?: any
  customLinkProps?: any
  customProps?: {
    className?: string
  }
}

const containerProps: PrensaEngineCSSProp = {
  align: ['column', 'left', 'top'],
  mt: '$2',
  mb: '$6',
  width: '100%'
}
const typographyHeadlineProps: PrensaEngineCSSProp = {
  fontFamily: '$primary',
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '19px',
  p: '$0',
  m: '$0',
  mb: '$1'
}

const EditaisTeaser: React.FC<EditaisTeaserProps> = (props) => {
  const isDesktop = props?.customProps?.className?.includes('desktop')
  if (isDesktop) return <></>
  const articleId = get(props, 'id', '').replace('policy:', '')
  const articleCompany = get(props, 'title', get(props, 'name', ''))
  const articleHref = `item-${articleId}`
  const articleLinkPath = get(window, 'location.pathname', '/')
  const publishingTime = get(props, 'publishingTime', false)
  const publishedDate = convertLocaleDateWithoutTime(publishingTime, false)
  return (
    <Block css={containerProps}>
      <Link
        component={props.customLink}
        componentProps={props.customLinkProps}
        href={`${articleLinkPath}/${articleHref}`}
      >
        <Typography css={typographyHeadlineProps} as='p'>
          {publishedDate} | {articleCompany}
        </Typography>
      </Link>
    </Block>
  )
}

export default EditaisTeaser
